var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { ErrorHandler } from '../core/error.service';
/**
 * Api services for the `Customers` model.
 */
var CustomersApi = /** @class */ (function (_super) {
    __extends(CustomersApi, _super);
    function CustomersApi(http, models, auth, errorHandler) {
        var _this = _super.call(this, http, models, auth, errorHandler) || this;
        _this.http = http;
        _this.models = models;
        _this.auth = auth;
        _this.errorHandler = errorHandler;
        return _this;
    }
    /**
     * Get team members
     *
     * @param {any} id Customers id
     *
     * @param {object} filter
     *
     * @returns {object[]} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Customers` object.)
     * </em>
     */
    CustomersApi.prototype.listTeam = function (id, filter, customHeaders) {
        if (filter === void 0) { filter = {}; }
        var _method = "GET";
        var _url = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
            "/customers/:id/team";
        var _routeParams = {
            id: id
        };
        var _postBody = {};
        var _urlParams = {};
        if (typeof filter !== 'undefined' && filter !== null)
            _urlParams.filter = filter;
        var result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
        return result;
    };
    /**
     * Assign team member
     *
     * @param {any} id Customers id
     *
     * @param {string} memberId
     *
     * @param {object} data Request data.
     *
     *  - `role` – `{string}` -
     *
     * @returns {object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Customers` object.)
     * </em>
     */
    CustomersApi.prototype.addTeam = function (id, memberId, role, customHeaders) {
        if (memberId === void 0) { memberId = {}; }
        if (role === void 0) { role = {}; }
        var _method = "PUT";
        var _url = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
            "/customers/:id/team/:memberId";
        var _routeParams = {
            id: id,
            memberId: memberId
        };
        var _postBody = {};
        var _urlParams = {};
        if (typeof role !== 'undefined' && role !== null)
            _urlParams.role = role;
        var result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
        return result;
    };
    /**
     * Remove team member
     *
     * @param {any} id Customers id
     *
     * @param {string} memberId
     *
     * @returns {object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * This method returns no data.
     */
    CustomersApi.prototype.removeTeam = function (id, memberId, customHeaders) {
        if (memberId === void 0) { memberId = {}; }
        var _method = "DELETE";
        var _url = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
            "/customers/:id/team/:memberId";
        var _routeParams = {
            id: id,
            memberId: memberId
        };
        var _postBody = {};
        var _urlParams = {};
        var result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
        return result;
    };
    /**
     * Add a file
     *
     * @param {any} id Customers id
     *
     * @param {object} data Request data.
     *
     * This method expects a subset of model properties as request parameters.
     *
     * @returns {object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Customers` object.)
     * </em>
     */
    CustomersApi.prototype.addFile = function (id, update, customHeaders) {
        if (update === void 0) { update = {}; }
        var _method = "POST";
        var _url = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
            "/customers/:id/files";
        var _routeParams = {
            id: id
        };
        var _postBody = {
            update: update
        };
        var _urlParams = {};
        var result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
        return result;
    };
    /**
     * Remove a file
     *
     * @param {any} id Customers id
     *
     * @param {string} fileId The id of the file to remove
     *
     * @returns {object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * This method returns no data.
     */
    CustomersApi.prototype.removeFile = function (id, fileId, customHeaders) {
        if (fileId === void 0) { fileId = {}; }
        var _method = "DELETE";
        var _url = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
            "/customers/:id/files/:fileId";
        var _routeParams = {
            id: id,
            fileId: fileId
        };
        var _postBody = {};
        var _urlParams = {};
        var result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
        return result;
    };
    /**
     * Customer check-in
     *
     * @param {any} id Customers id
     *
     * @param {object} data Request data.
     *
     * This method expects a subset of model properties as request parameters.
     *
     * @returns {object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * The check-in record
     */
    CustomersApi.prototype.createCheckIn = function (id, checkin, customHeaders) {
        if (checkin === void 0) { checkin = {}; }
        var _method = "POST";
        var _url = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
            "/customers/:id/checkIns";
        var _routeParams = {
            id: id
        };
        var _postBody = {
            checkin: checkin
        };
        var _urlParams = {};
        var result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
        return result;
    };
    /**
     * List check-ins
     *
     * @param {any} id Customers id
     *
     * @param {object} filter
     *
     * @returns {object[]} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * The list of check-in records for this customer
     */
    CustomersApi.prototype.listCheckIns = function (id, filter, customHeaders) {
        if (filter === void 0) { filter = {}; }
        var _method = "GET";
        var _url = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
            "/customers/:id/checkIns";
        var _routeParams = {
            id: id
        };
        var _postBody = {};
        var _urlParams = {};
        if (typeof filter !== 'undefined' && filter !== null)
            _urlParams.filter = filter;
        var result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
        return result;
    };
    /**
     * Create memo for customer (Deprecated)
     *
     * @param {any} id Customers id
     *
     * @param {object} data Request data.
     *
     * This method expects a subset of model properties as request parameters.
     *
     * @returns {object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * The created memo
     */
    CustomersApi.prototype.createMemo = function (id, memo, customHeaders) {
        if (memo === void 0) { memo = {}; }
        var _method = "POST";
        var _url = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
            "/customers/:id/memos";
        var _routeParams = {
            id: id
        };
        var _postBody = {
            memo: memo
        };
        var _urlParams = {};
        var result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
        return result;
    };
    /**
     * Get memo statistics
     *
     * @param {any} id Customers id
     *
     * @returns {object[]} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Customers` object.)
     * </em>
     */
    CustomersApi.prototype.memoStats = function (id, customHeaders) {
        var _method = "GET";
        var _url = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
            "/customers/:id/memos/stats";
        var _routeParams = {
            id: id
        };
        var _postBody = {};
        var _urlParams = {};
        var result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
        return result;
    };
    /**
     * Request access
     *
     * @param {any} id Customers id
     *
     * @param {object} data Request data.
     *
     *  - `role` – `{string}` - The requested role - defaults to CUSTOMER_CARER
     *
     * @returns {object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Customers` object.)
     * </em>
     */
    CustomersApi.prototype.requestAccess = function (id, role, customHeaders) {
        if (role === void 0) { role = {}; }
        var _method = "PUT";
        var _url = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
            "/customers/:id/accessRequests";
        var _routeParams = {
            id: id
        };
        var _postBody = {};
        var _urlParams = {};
        if (typeof role !== 'undefined' && role !== null)
            _urlParams.role = role;
        var result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
        return result;
    };
    /**
     * Update customer
     *
     * @param {any} id Customers id
     *
     * @param {object} data Request data.
     *
     * This method expects a subset of model properties as request parameters.
     *
     * @returns {object} An empty reference that will be
     *   populated with the actual data once the response is returned
     *   from the server.
     *
     * <em>
     * (The remote method definition does not provide any description.
     * This usually means the response is a `Customers` object.)
     * </em>
     */
    CustomersApi.prototype.updateById = function (id, update, customHeaders) {
        if (update === void 0) { update = {}; }
        var _method = "PUT";
        var _url = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
            "/customers/:id";
        var _routeParams = {
            id: id
        };
        var _postBody = {
            update: update
        };
        var _urlParams = {};
        var result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
        return result;
    };
    /**
     * The name of the model represented by this $resource,
     * i.e. `Customers`.
     */
    CustomersApi.prototype.getModelName = function () {
        return "Customers";
    };
    CustomersApi.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    CustomersApi.ctorParameters = function () { return [
        { type: HttpClient, decorators: [{ type: Inject, args: [HttpClient,] }] },
        { type: SDKModels, decorators: [{ type: Inject, args: [SDKModels,] }] },
        { type: LoopBackAuth, decorators: [{ type: Inject, args: [LoopBackAuth,] }] },
        { type: ErrorHandler, decorators: [{ type: Optional }, { type: Inject, args: [ErrorHandler,] }] }
    ]; };
    return CustomersApi;
}(BaseLoopBackApi));
export { CustomersApi };
//# sourceMappingURL=Customers.js.map